import { render, staticRenderFns } from "./DashboardPermisos.vue?vue&type=template&id=6e517637"
import script from "./DashboardPermisos.vue?vue&type=script&lang=js"
export * from "./DashboardPermisos.vue?vue&type=script&lang=js"
import style0 from "./DashboardPermisos.vue?vue&type=style&index=0&id=6e517637&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports